// extracted by mini-css-extract-plugin
export default {"heading":"Credits_heading__MxYAL","title":"Credits_title__N2QRm","names":"Credits_names__fjRNo","credits_detail":"Credits_credits_detail__DJYXg"};